<template>
    <!-- nav -->
    <div class="container-fluid header-container">
        <div class="row header">
            <div class="">
                <a :href="url"><img src="/static/logo.png" alt="酝智文化传媒" style="height: 60px;"></a>
            </div>
            <div class="" style="">
                <ul id="top-menu" class="navbars navs navs-topbar">

                    <li v-for="(item,index) in navs" :key="index">
                        <router-link :to="item.url" exact>{{item.name}}</router-link>
                    </li>
					<li v-if="hasLogin">
						<router-link to="/User" exact>个人中心</router-link>
					</li>
					<li v-else>
						<a class="login" @click="login">登录</a>
					</li>
                </ul>
            </div>
        </div>
		<!-- 登录注册框 -->
		<login :isLogin="isLogin" @loginVisible="loginVisible()" @loginSuccess="loginSuccess"></login>
    </div>
</template>

<script>
import $C from '@/common/config.js'
import $H from '@/common/request.js'
import login from '../login/Login'
export default {
  components: {
	    login
  },
  name: 'header-bar',
  data () {
    return {
      url: $C.site,
      navs: [
        {name: '首页', url: '/'},
        // {name:"期刊目录",url:"/Qikan"},
        // {name:"专著出版",url:"/Publish"},
        // {name:"知识产权",url:"/qikan"},
        {name: '其他', url: '/Notice'},
        {name: '联系我们', url: '/Contact'}
        // {name:"个人中心",url:"/User"},

      ],
      hasLogin: false,
      isLogin: false
    }
  },
  mounted () {
    let user = localStorage.getItem('loginUser')
    let loginTime = localStorage.getItem('loginTime')
    if (user) {
      user = JSON.parse(user)
      if (loginTime) {
        let time = Math.round(new Date().getTime() / 1000)
        if (time - Number(loginTime) < 86400) {
          this.hasLogin = true
        }
      }
    }
  },
  methods: {
    login () {
      this.isLogin = true
    },
    loginVisible () {
		    this.isLogin = false
    },
    loginSuccess () {
		    this.isLogin = false
		    this.hasLogin = true
		    let user = localStorage.getItem('loginUser')
		    let loginTime = localStorage.getItem('loginTime')
		    if (user) {
		        console.log(user)
		        user = JSON.parse(user)
		        if (loginTime) {
		            let time = Math.round(new Date().getTime() / 1000)
		            if (time - Number(loginTime) > 86400) {
		                this.hasLogin = false
		            } else {
		                if (user.access_token) {
		                    this.hasLogin = true
		                    this.user = user
		                }
		            }
		        }
		    }
		    location.reload()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header{
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 30px;
}
.header-container{
    margin: 0 auto;
}
.link-active{
    color:#4CADD3;
}
.login{
	cursor:pointer;
	color:#646464 !important;
}
.login :hover{
	color:#4CADD3 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/header/Header.vue